import { FlagFilled } from '@metrika/ui-kit/icons/carbon';
import React from 'react';
import { createPortal } from 'react-dom';
import { useFlags, useSetFlag } from '../../_env';
import { IconButton } from '../../search/SearchButton';
import { DebugMainPanel } from './DebugMainPanel';
import Dock from './react-dock/Dock';

export function DebugIcon() {
   const { debugShow, debugEnabled } = useFlags();
   const setFlag = useSetFlag();
   const [size, setSize] = React.useState(256);
   if (!debugEnabled) return null;
   return (
      <>
         <IconButton>
            <FlagFilled size={20} onClick={() => setFlag('debugShow', !debugShow)} />
         </IconButton>
         {createPortal(
            <Dock
               position="left"
               onSizeChange={setSize}
               isVisible={debugShow}
               size={size}
               fluid={false}
               onVisibleChange={() => setFlag('debugShow', !debugShow)}
            >
               <DebugMainPanel />
            </Dock>,
            document.body,
         )}
      </>
   );
}
